

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { fetchOrganizationDetails } from "../../Store/IAM/iamSlice";
import remarkIcon from "./Frame 433.png";
import searchIcon from "./search.png";
import moment from "moment";
import "./iamSidebar.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import refreshIcon from "./refresh.png";



const InspectSuper = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [auditData, setAuditData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [startDate, setStartDate] = useState(moment().startOf('month').format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [selectedOrg, setSelectedOrg] = useState(""); // State for selected organization
  const [selectedProgram, setSelectedProgram] = useState(""); // State for selected organization
  const [selectedCaseId, setSelectedCaseId] = useState(""); // State for selected case ID
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [agents, setAgents] = useState({});
  const [caseIds, setCaseIds] = useState([]); // State for case IDs
  const [orgNames, setOrgNames] = useState([]); // State for case IDs
  const [progNames, setProgNames] = useState([]); // State for case IDs
  const user = localStorage.getItem("insuranceUser");
  const user_info = JSON.parse(user);
  // const exportToExcel = () => {
  //   // Filter only processed rows
  //   const processedData = filteredData.filter(row => row.status.toLowerCase() === "processed");

  //   const exportData = processedData.map(row => ({
  //     Date: row.date,
  //     "Case ID": row.caseId,
  //     Status: row.status,
  //     Report: pdfLinks[row.audit] ? pdfLinks[row.audit] : "Not generated",
  //     "Organisation Name": row.orgName,
  //     Remark: row.remark || "N/A",
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(exportData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Audit Report");

  //   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //   const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(dataBlob, `Processed_Audit_Report_${moment().format("YYYY-MM-DD_HH-mm")}.xlsx`);
  // };

  //   const exportToExcel = () => {
  //   // Filter only processed rows
  //   const processedData = filteredData.filter(
  //     row => row.status.toLowerCase() === "processed"
  //   );

  //   const exportData = processedData.map(row => ({
  //     Date: row.date,
  //     "Case ID": row.caseId,
  //     Status: row.status,
  //     Report: pdfLinks[row.audit] ? pdfLinks[row.audit] : "Not generated",
  //     "Organisation Name": row.orgName,
  //     Remark: row.remark || "N/A",
  //     "Feedback (Rating)": row.feedback || "N/A", // ✅ keep only feedback now
  //   }));

  //   // Create worksheet and export
  //   const worksheet = XLSX.utils.json_to_sheet(exportData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Processed Data");
  //   XLSX.writeFile(workbook, "Processed_Data.xlsx");
  // };
  const exportToExcel = () => {
    // Filter only processed rows
    const processedData = filteredData.filter(
      row => row.status.toLowerCase() === "processed"
    );
    console.log("84", processedData);

    const exportData = processedData.map(row => ({
      Date: row.date,
      "Case ID": row.caseId,
      Status: row.status,
      Report: pdfLinks[row.audit] ? pdfLinks[row.audit] : "Not generated",
      "Organisation Name": row.orgName,
      "Vehicle Number": row.vehicleNo || "N/A",
      "Policy Type": row.policyType || "N/A", // ✅ only in Excel
      Remark: row.remark || "N/A",
      "VISoF UniqueReferenceNo": row.VISoF_UniqueReferenceNo || 'N/A',
      "Feedback (Rating)": row.feedback || "N/A",
      "Dealer Code": row.DealerCode || " "
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Processed Data");
    XLSX.writeFile(workbook, "Processed_Data.xlsx");
  };


  const fetchAuditData = async () => {
    setIsRefreshing(true);
    try {
      const response = await axios.post("/auth/allOrgData", { startDate, endDate }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const apiResponse = response.data;
      console.log("113", apiResponse)

      // Step 1: Flatten backend data
      let orgData = apiResponse.flatMap(org =>
        org.orgData.map(data => ({
          ...data,
          orgName: org.orgName, // default
          programName: org.programName
        }))
      );

      // Step 2: Collect all audit IDs
      const auditIds = orgData.map(row => row.audit).filter(Boolean);

      // Step 3: Fetch S3 details in batch
      const batchResponse = await axios.post('/auth/batch_check_and_get_details', { auditIds });
      const batchData = batchResponse.data.audits;
      // console.log("131",batchResponse);
      console.log("132", batchData);

      // Step 4: Map insuranceCompany from batch results
      // Step 4: Map insuranceCompany and PI Type from batch results
      const batchMap = batchData.reduce((acc, item) => {
        acc[item.id] = {
          insuranceCompany: item.details["Insurance Company"] || '',
          piType: item.details["PI Type"] || '',
          vehicleNo: item.details["Vehicle No"] || '',
          DealerCode: item.details["Dealer Code"] || '',
        };
        return acc;

      }, {});



      orgData = orgData.map(row => ({
        ...row,
        orgName: batchMap[row.audit]?.insuranceCompany || row.orgName || '',
        policyType: batchMap[row.audit]?.piType || '',      // ✅ PI Type
        vehicleNo: batchMap[row.audit]?.vehicleNo || 'N/A', // ✅ Vehicle Number
        DealerCode: batchMap[row.audit]?.DealerCode || ''
      }));


      // Step 5: Filter by date
      const filteredByDate = orgData.filter(row => {
        if (!row.date) return false;
        const rowDate = moment(row.date).startOf("day");
        return rowDate.isSameOrAfter(moment(startDate).startOf("day")) &&
          rowDate.isSameOrBefore(moment(endDate).startOf("day"));
      });

      // Step 6: Unique IDs / Names
      setCaseIds([...new Set(filteredByDate.map(row => row.audit))]);
      setOrgNames([...new Set(filteredByDate.map(row => row.orgName))]);
      setProgNames([...new Set(filteredByDate.map(row => row.programName))]);

      // Step 7: Format table data
      const formattedData = filteredByDate.map(row => ({
        date: moment(row.date).format("YYYY-MM-DD HH:mm:ss"),
        caseId: row.audit,
        name: row.name || "xyz",
        status: row.used,
        audit: row.audit,
        orgName: row.orgName || "Unknown Insurance Company",
        remark: row.remark,
        VISoF_UniqueReferenceNo: row.VISoF_UniqueReferenceNo,
        userID: row.userID,
        programName: row.programName,
        feedback: row.Rating,
        policyType: row.policyType || "N/A",
        vehicleNo: row.vehicleNo || '',
        DealerCode: row.DealerCode || ''
      }));

      formattedData.sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf());

      setOriginalAuditData(formattedData);
      setAuditData(formattedData);
      setIsDataFetched(true);

    } catch (error) {
      console.error("Error fetching audit data:", error);
      setAuditData([]);
      setIsDataFetched(true);
    } finally {
      setIsRefreshing(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    }
  };



  const toggleOrgSort = () => {
    let sortedData;

    if (orgSortOrder === "default" || orgSortOrder === "desc") {
      sortedData = [...auditData].sort((a, b) =>
        a.orgName.localeCompare(b.orgName)
      );
      setOrgSortOrder("asc");
    } else if (orgSortOrder === "asc") {
      sortedData = [...auditData].sort((a, b) =>
        b.orgName.localeCompare(a.orgName)
      );
      setOrgSortOrder("desc");
    }

    setAuditData(sortedData);
  };
  useEffect(() => {
    if (!startDate || !endDate) return;


    if (moment(startDate).isAfter(moment(endDate))) {
      setEndDate(startDate);
      return;
    }
    fetchAuditData();
  }, [startDate, endDate]); // Trigger fetch when either date changes


  const toggleDateSort = () => {
    let sortedData;

    if (dateSortOrder === "default" || dateSortOrder === "asc") {
      sortedData = [...auditData].sort(
        (a, b) => new Date(b.date) - new Date(a.date) // Latest first
      );
      setDateSortOrder("desc");
    } else {
      sortedData = [...auditData].sort(
        (a, b) => new Date(a.date) - new Date(b.date) // Oldest first
      );
      setDateSortOrder("asc");
    }

    setAuditData(sortedData);
  };
  // useEffect(() => {
  //   fetchAuditData();
  // }, [selectedDate]); // Runs every time selectedDate changes

  // Filter data based on selected filters
  const filteredData = auditData.filter((row) =>
    // Case ID filter
    (row.caseId.toLowerCase().includes(selectedCaseId.toLowerCase()) || !selectedCaseId) &&

    // Org filter
    (row.orgName.toLowerCase().includes(selectedOrg.toLowerCase()) || !selectedOrg) &&

    // Program filter
    (row.programName?.toLowerCase().includes(selectedProgram.toLowerCase()) || !selectedProgram) &&

    // Search filter (caseId or status)
    (
      row.caseId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.status.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );


  const link_to_pdf = async (audit_id) => {
    // ✅ S3 object key format (must match backend convention)
    const objectKey = `Insurance_Inspection/downloadedPdf/${audit_id}.pdf`;

    try {
      const response = await fetch("/auth/check_document_exists", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ objectKey }), // ✅ send S3 key
      });

      const data = await response.json();
      // console.log("S3 PDF response:", audit_id, data);

      if (data.exists && data.url) {
        return data.url; // signed S3 URL if found
      } else {
        return null; // file not found
      }
    } catch (error) {
      console.error("Error fetching signed S3 URL:", error);
      return null;
    }
  };


  const [pdfLinks, setPdfLinks] = useState({});

  useEffect(() => {
    const checkAllLinks = async () => {
      const links = {};
      for (const row of auditData) {
        const url = await link_to_pdf(row.audit); // 🔍 check S3 here
        if (url) {
          links[row.audit] = url;
        }
      }
      setPdfLinks(links);
    };

    if (auditData.length > 0) {
      checkAllLinks();
    }
  }, [auditData]);

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case "processing":
        return { backgroundColor: "rgba(247, 165, 29, 1)", color: "white" };
      case "processed":
      case "completed":
        return { backgroundColor: "rgba(31, 68, 136, 1)", color: "white" };
      case "accessed":
        return { backgroundColor: "#ff0083", color: "white" };
      default:
        return { backgroundColor: "grey", color: "white" };
    }
  };
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const token = user_info.token; const [isRefreshing, setIsRefreshing] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [orgSortOrder, setOrgSortOrder] = useState("default"); // none | asc | desc
  const [originalAuditData, setOriginalAuditData] = useState([]); // to restore
  const [dateSortOrder, setDateSortOrder] = useState("default");




  return (
    <div className="inspect-container">
      <div className="card">
        <div className="card-header">
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h2 style={{ margin: 0 }}>Inspect</h2>
            <img
              src="https://w7.pngwing.com/pngs/1015/1010/png-transparent-user-interface-download-cloud-down-arrow-ui-user-interface-icon.png"
              alt="Download"
              title="Download as Excel"
              onClick={exportToExcel} // You’ll add Excel download here
              style={{
                width: "15px",
                height: "15px",
                cursor: "pointer",
                // filter: "brightness(0) saturate(100%) invert(31%) sepia(17%) saturate(2390%) hue-rotate(182deg) brightness(97%) contrast(89%)"
              }}
            />
          </div>
          <div className="search-refresh-wrapper" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div className="search-bar" style={{ flex: 1 }}>
              <input
                type="text"
                placeholder="Search ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: "100%" }}
              />
              <img src={searchIcon} alt="Search" className="search-icon" />
            </div>

            {/* Total audits count badge in the middle */}
            <div
              style={{
                backgroundColor: "#1f4488",
                color: "white",
                padding: "2px 12px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "bold",
                minWidth: "40px",
                textAlign: "center",
              }}
              title="Total audits for current date range"
            >
              {filteredData.length}
            </div>

            <div
              className={`refresh-icon-wrapper ${isRefreshing ? "spinning" : ""}`}
              onClick={fetchAuditData}
              title="Refresh"
              style={{ display: "flex", alignItems: "center" }}
            >
              <img src={refreshIcon} alt="refresh" className="refresh-icon" />
            </div>
          </div>


        </div>
        {showToast && (
          <div className="toast-popup">
            Table Refreshed
          </div>
        )}


        {/* <div className="filters">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <select onChange={(e) => setSelectedOrg(e.target.value)}>
            <option value=""> All Insurance Company</option>
            {orgNames.map((orgName) => (
              <option key={orgName} value={orgName}>
                {orgName}
              </option>
            ))}
          </select>
          <select onChange={(e) => setSelectedOrg(e.target.value)}>
            <option value="">All Program</option>
            {orgNames.map((orgName) => (
              <option key={orgName} value={orgName}>
                {orgName}
              </option>
            ))}
          </select>
          <select onChange={(e) => setSelectedCaseId(e.target.value)}>
            <option value=""> All Case ID</option>
            {caseIds.map((caseId) => (
              <option key={caseId} value={caseId}>
                {caseId}
              </option>
            ))}
          </select>
        </div> */}
        <div className="filters">
          <input
            type="date"
            value={startDate}
            // onChange={(e) => setStartDate(e.target.value)}
            onChange={(e) => {
              const newStart = e.target.value;
              setStartDate(newStart);
              if (moment(newStart).isAfter(moment(endDate))) {
                setEndDate(newStart);
              }
            }}

          />
          <input
            type="date"
            value={endDate}
            min={startDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          {/* Insurance Company filter */}
          <select onChange={(e) => setSelectedOrg(e.target.value)}>
            <option value="">All Insurance Company</option>
            {orgNames.map((orgName) => (
              <option key={orgName} value={orgName}>
                {orgName}
              </option>
            ))}
          </select>

          {/* Program filter */}
          <select onChange={(e) => setSelectedProgram(e.target.value)}>
            <option value="">All Program</option>
            {progNames.map((progName) => (
              <option key={progName} value={progName}>
                {progName}
              </option>
            ))}
          </select>

          {/* Case ID filter */}
          <select onChange={(e) => setSelectedCaseId(e.target.value)}>
            <option value="">All Case ID</option>
            {caseIds.map((caseId) => (
              <option key={caseId} value={caseId}>
                {caseId}
              </option>
            ))}
          </select>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  Date
                  <span
                    className="sort-icon"
                    onClick={toggleDateSort}
                    title="Sort by Date"
                    style={{ marginLeft: "5px", cursor: "pointer" }}
                  >
                    ⬍
                  </span>
                </th>

                <th>Case ID</th>
                <th>Status</th>
                <th>Report</th>
                <th>Program Name</th>  {/* Add this line for Program Name */}
                <th>
                  Insurance Company
                  <span
                    className="sort-icon"
                    onClick={toggleOrgSort}
                    title="Sort by Org Name"
                    style={{ marginLeft: "5px", cursor: "pointer" }}
                  >
                    ⬍
                  </span>
                </th>


                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              {!isDataFetched ? (
                <tr>
                  <td colSpan="6" className="no-results">
                    No data available
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.date}</td>
                    <td>{row.caseId}</td>
                    <td>
                      <span className="status" style={getStatusClass(row.status)}>
                        {row.status}
                      </span>
                    </td>

                    <td>
                      {row.status === "processed" && pdfLinks[row.audit] ? (
                        <a
                          href={pdfLinks[row.audit]}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#ff0083",
                            textDecoration: "none",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "inline-block",
                            maxWidth: "150px",
                            verticalAlign: "middle",
                            padding: "2px",
                          }}
                          title={pdfLinks[row.audit]}
                        >
                          View
                        </a>
                      ) : (
                        "Not generated"
                      )}
                    </td>
                    <td>{row.programName || "-"}</td>


                    <td>{row.orgName}</td>

                    <td>
                      {row.remark && row.status === "processed" ? (
                        <div
                          className="tooltip-container clickable"
                          title={row.remark}
                          onClick={() => {
                            setSelectedRemark(row.remark);
                            setShowRemarkPopup(true);
                          }}
                        >
                          <img
                            src={remarkIcon}
                            alt="Remark"
                            className="remark-icon"
                            style={{
                              filter:
                                "brightness(90) saturate(0%) invert(21%) sepia(92%) saturate(7030%) hue-rotate(308deg) brightness(100%) contrast(124%)",
                            }}
                          />
                        </div>
                      ) : (
                        <div className="tooltip-container">
                          <img
                            src={remarkIcon}
                            alt="No Remark"
                            className="remark-icon"
                            style={{
                              filter: "grayscale(100%) brightness(80%)",
                            }}
                          />
                        </div>
                      )}
                    </td>



                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="no-results">
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showRemarkPopup && (
        <div className="remark-popup-overlay" onClick={() => setShowRemarkPopup(false)}>
          <div className="remark-popup" onClick={(e) => e.stopPropagation()}>
            <h3>Remark</h3>
            <p>{selectedRemark}</p>
            <button onClick={() => setShowRemarkPopup(false)}>Close</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default InspectSuper;





